<template>
  <div id="page-product-details">
    <market-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Market Create"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.markets.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import MarketForm from '@/views/pages/facilities/markets/MarketForm';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "MarketCreate",
  components: {
    MarketForm,
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {
      },
      modelEntity: this.$api.facilities.markets,
      entity: 'Market',
      loading: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      this.setDates(['InceptionDate', 'ExpiryDate'])

      params.Facility_FK = this.id;

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.facilities.markets.create(params);
        this.notifySuccess('Market created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Market failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
